/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DryRunAction } from './DryRunAction';
import {
    DryRunActionFromJSON,
    DryRunActionFromJSONTyped,
    DryRunActionToJSON,
    DryRunActionToJSONTyped,
} from './DryRunAction';

/**
 * How one transition evaluated during a dry run.
 * @export
 * @interface DryRunTransition
 */
export interface DryRunTransition {
    /**
     * 
     * @type {string}
     * @memberof DryRunTransition
     */
    transition: string;
    /**
     * 
     * @type {string}
     * @memberof DryRunTransition
     */
    fromStatus: string;
    /**
     * 
     * @type {string}
     * @memberof DryRunTransition
     */
    toStatus: string;
    /**
     * 
     * @type {number}
     * @memberof DryRunTransition
     */
    priority: number;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunTransition
     */
    fromStatusMatches: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunTransition
     */
    conditionResult: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DryRunTransition
     */
    error: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunTransition
     */
    fires: boolean;
    /**
     * 
     * @type {Array<DryRunAction>}
     * @memberof DryRunTransition
     */
    actions: Array<DryRunAction>;
}

/**
 * Check if a given object implements the DryRunTransition interface.
 */
export function instanceOfDryRunTransition(value: object): value is DryRunTransition {
    if (!('transition' in value) || value['transition'] === undefined) return false;
    if ((!('fromStatus' in (value as Record<string, any>)) && !('from_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['fromStatus'] === undefined && (value as Record<string, any>)['from_status'] === undefined)) return false;
    if ((!('toStatus' in (value as Record<string, any>)) && !('to_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['toStatus'] === undefined && (value as Record<string, any>)['to_status'] === undefined)) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if ((!('fromStatusMatches' in (value as Record<string, any>)) && !('from_status_matches' in (value as Record<string, any>))) || ((value as Record<string, any>)['fromStatusMatches'] === undefined && (value as Record<string, any>)['from_status_matches'] === undefined)) return false;
    if ((!('conditionResult' in (value as Record<string, any>)) && !('condition_result' in (value as Record<string, any>))) || ((value as Record<string, any>)['conditionResult'] === undefined && (value as Record<string, any>)['condition_result'] === undefined)) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    if (!('fires' in value) || value['fires'] === undefined) return false;
    if (!('actions' in value) || value['actions'] === undefined) return false;
    return true;
}

export function DryRunTransitionFromJSON(json: any): DryRunTransition {
    return DryRunTransitionFromJSONTyped(json, false);
}

export function DryRunTransitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DryRunTransition {
    if (json == null) {
        return json;
    }
    return {
        
        'transition': json['transition'],
        'fromStatus': json['from_status'],
        'toStatus': json['to_status'],
        'priority': json['priority'],
        'fromStatusMatches': json['from_status_matches'],
        'conditionResult': json['condition_result'],
        'error': json['error'],
        'fires': json['fires'],
        'actions': ((json['actions'] as Array<any>).map(DryRunActionFromJSON)),
    };
}

export function DryRunTransitionToJSON(json: any): DryRunTransition {
    return DryRunTransitionToJSONTyped(json, false);
}

export function DryRunTransitionToJSONTyped(value?: DryRunTransition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition': value['transition'],
        'from_status': value['fromStatus'],
        'to_status': value['toStatus'],
        'priority': value['priority'],
        'from_status_matches': value['fromStatusMatches'],
        'condition_result': value['conditionResult'],
        'error': value['error'],
        'fires': value['fires'],
        'actions': ((value['actions'] as Array<any>).map(DryRunActionToJSON)),
    };
}

